const state = () => ({ value: null });
const getters = { get: state => state.value };
const mutations = { set: (state, value) => (state.value = value) };
const actions = { set: ({ commit }, value) => commit('set', value) };

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
